import { SquaresFour } from '@phosphor-icons/react';

const DefaultView = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <SquaresFour
        data-testid="test-default-view-img"
        size={250}
        className="text-gray-300"
      />
      <label
        data-testid="test-default-view-message"
        className="font-semibold text-gray-600"
      >
        There is nothing here yet
      </label>
    </div>
  );
};

export default DefaultView;
